import React, { useState } from 'react'
import {
  Row,
  Col,
  Spin,
  Button,
  Form,
  Input,
  Checkbox,
  Select,
  Divider,
  message,
  InputNumber,
  Modal
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import ds from '../../../Services/DataServices'
import { parse } from '@babel/core'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { isEmailValid, notAllowMsgCheck } from '../../../appRedux/actions'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { OUTLETREGISTER_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { useSelector, useDispatch } from 'react-redux'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const confirm = Modal.confirm

const EditOutlet = ({ match }) => {
  const outletID = match.params.id ? match.params.id : false
  const showDelButton = match.params.showDel ? match.params.showDel : false
  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )

  const [confirmLoading, setConfirmLoading] = useState(true) // change state
  const [getCountryData, setgetCountryData] = useState([{ id: 0, label: '' }])
  const [outletData, setOutletData] = useState([])
  const [taxData, setTaxData] = useState([])
  const [getIsWarnInventory, setIsWarnInventory] = useState(false)
  const [getIsWarnCustomer, setIsWarnCustomer] = useState(false)
  const [getOutletName, setOutletName] = useState('')
  const [getTimeZoneList, setTimeZoneList] = useState([])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'setup.salesTax.editOutletTitle')
    }

    dispatch(setCommonConfigs(OUTLETREGISTER_SCREEN))
    if (outletID) {
      let body = {
        OutletID: outletID
      }
      getOutletRegService(body)
    }
  }, [])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  async function getOutletRegService (body) {
    await ds
      .getCountries()
      .then(res => {
        setgetCountryData(res)
      })
      .then(() => {
        ds.getTaxList('', BEHAVIOUR_TYPE.GET)
          .then(res => {
            let array = res.map(e => {
              return {
                id: parseInt(
                  e.salesTaxSId.substring(0, e.salesTaxSId.indexOf('&'))
                ),
                salesTaxName: e.salesTaxName
              }
            })
            setTaxData(array)
          })
          .catch(e => {
            notAllowMsgCheck(e)
            setConfirmLoading(false)
            message.error('Something went wrong')
          })
      })
      .then(() => {
        ds.getOutletAndRegister(body, BEHAVIOUR_TYPE.GET)
          .then(res => {
            setConfirmLoading(false)
            if (res.outletAndRegisterLists.length > 0) {
              let data = res.outletAndRegisterLists[0]
              if (res.timeZones && res.timeZones.length > 0) {
                setTimeZoneList(res.timeZones)
              }
              setOutletData(data)
              setIsWarnInventory(
                data.warnForInventory ? data.warnForInventory : false
              )
              setIsWarnCustomer(
                data.warnForCustomer ? data.warnForCustomer : false
              )
              setOutletName(data.outletName ? data.outletName : '')
              form.setFieldsValue({
                outletName: data.outletName ? data.outletName : '',
                orderNoPrefix: data.orderNoPrefix ? data.orderNoPrefix : 'RAW',
                orderNo: data.orderNo ? data.orderNo : 1,
                Country: data.countryID ? data.countryID : '',
                Email: data.email ? data.email : '',
                City: data.cityName ? data.cityName : '',
                Phone: data.phone ? data.phone : '',
                StoreAddress: data.storeAddress ? data.storeAddress : '',
                zipCodeXYZ: data.zipCode ? data.zipCode : 0,
                // taxValueXYZ: data.taxValue ? data.taxValue : 0,
                SupplierReturn: data.supplierReturnPrefix
                  ? data.supplierReturnPrefix
                  : 'RAW',
                DefaultSalesTax: data.salesTaxID
                  ? parseInt(
                      data.salesTaxID.substring(0, data.salesTaxID.indexOf('&'))
                    )
                  : 1,
                SupplierReturnNo: data.supplierReturnNo
                  ? data.supplierReturnNo
                  : 1,
                TimeZone:
                  data.timeZoneID && data.timeZoneID > 0 ? data.timeZoneID : '',
                Twitter: data.twitter ? data.twitter : ''
              })
            }
          })
          .catch(error => {
            notAllowMsgCheck(error)
            message.error('Something went wrong')
            setConfirmLoading(false)
          })
      })
      .catch(error => {
        setConfirmLoading(false)
      })
  }

  async function postOutletRegService (body, methodType) {
    // ;
    await ds
      .postOutletAndRegister(body, methodType)
      .then(res => {
        if (res == 'Saved') {
          setConfirmLoading(false)
          message.success('Outlet Updated Successfully')
          setTimeout(() => {
            redirectToListing()
          }, 2000)
        } else if (res == 'Deleted') {
          setConfirmLoading(false)
          message.success('Outlet Deleted Successfully')
          setTimeout(() => {
            redirectToListing()
          }, 2000)
        } else if (res == 'Register present') {
          setConfirmLoading(false)
          message.warn(
            'Register assigned to the Outlet, first delete the registers',
            4
          )
          // setTimeout(() => {
          //   redirectToListing();
          // }, 2000);
        } else {
          setConfirmLoading(false)
          message.warn('Server down, Try Again Later...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)

        message.error('Error Occured')
      })
  }

  const redirectToListing = () => {
    history.push('/Dashboard/Setup/outletsandregisters/listing')
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly provide the missing info')
  }

  const onFinish = values => {
    if (outletID) {
      let body = {
        Behavior: 3,
        IsForOutlet: true,
        OutletId: outletID,
        OutletName: values.outletName,
        OutletAddress: values.StoreAddress ? values.StoreAddress : '',
        OutletCity: values.City ? values.City : '',
        ZipCode: values.zipCodeXYZ ? values.zipCodeXYZ : 0,
        CountryId: values.Country ? values.Country : 0,
        StoreOutletTaxID:
          getIsTaxExclusive && values.DefaultSalesTax
            ? values.DefaultSalesTax
            : 0,
        // TaxValue: values.taxValueXYZ,
        Email: values.Email ? values.Email : '',
        Phone: values.Phone ? values.Phone : '',
        SupplierReturnPrefix: values.SupplierReturn
          ? values.SupplierReturn
          : '',
        SupplierReturnNo: values.SupplierReturnNo
          ? parseInt(values.SupplierReturnNo)
          : 1,
        OrderNoPrefix: values.orderNoPrefix ? values.orderNoPrefix : '',
        OrderNo: values.orderNo ? parseInt(values.orderNo) : 1,
        WarnCustomer: getIsWarnCustomer,
        WarnInventory: getIsWarnInventory,
        TimeZoneID: values.TimeZone ? values.TimeZone : 0,
        Twitter: values.Twitter ? values.Twitter : ''
      }
      setConfirmLoading(true)
      postOutletRegService(body, BEHAVIOUR_TYPE.UPDATE)
    } else {
      message.error('Connection broke...')
      setTimeout(() => {
        redirectToListing()
      }, 2000)
    }
  }

  function onDeleteConfirm () {
    if (outletID) {
      let body = {
        Behavior: 2,
        IsForOutlet: true,
        OutletId: outletID
      }
      setConfirmLoading(true)
      postOutletRegService(body, BEHAVIOUR_TYPE.DELETE)
    } else {
      message.error('Connection broke...')
      setTimeout(() => {
        redirectToListing()
      }, 2000)
    }
  }

  function showDeleteConfirm () {
    confirm({
      title: 'Are you sure to delete this Outlet?',
      content: `"${getOutletName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        onDeleteConfirm()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }
  const validateNamePrefixInput = (rule, value, callback) => {
    const pattern = /^[A-Za-z0-9]{1,3}$/
    if (!pattern.test(value)) {
      callback(
        'Prefix can only have letters (A-Z) or numbers (0-9) and 3 or fewer characters.'
      )
    } else {
      callback()
    }
  }

  const validateNumberInput = (rule, value, callback) => {
    const numberValue = parseInt(value)
    if (isNaN(numberValue)) {
      callback('Input should be a number')
    } else if (numberValue <= 0) {
      callback('Input should be a positive number greater than 0')
    } else {
      callback()
    }
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={confirmLoading}
      size='large'
    >
      <>
        <div className='Content-wrapper Edit-Outlet'>
          <div className='back-arrow-h1'>
            {checkIsWeb().exist && (
              <h1 className='d-flex align-items-center'>
                <ArrowLeftOutlined
                  className='dk-vertical-align'
                  onClick={redirectToListing}
                />
                <span className='mx-2'>
                  <IntlMessages id='setup.salesTax.editOutletTitle' />
                </span>
              </h1>
            )}
          </div>

          <Form
            {...formItemLayout}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86'
            }}
            className=''
            scrollToFirstError
            id='EditOutletForm'
            name='EditOutletForm'
          >
            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mt-4'>
              <IntlMessages id='setup.salesTax.editOutletSubTitle1' />
            </h2>

            <Row className='Details-div'>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='outletName'
                  label={<IntlMessages id='setup.salesTax.salesTable2Label1' />}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter outlet name'
                    }
                  ]}
                >
                  <Input  maxLength={50}/>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='SupplierReturn'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel2' />
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Input field is required'
                    },
                    {
                      validator: validateNamePrefixInput
                    }
                  ]}
                >
                  <Input   maxLength={20}/>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='orderNoPrefix'
                  label={<IntlMessages id='setup.salesTax.editSalesTaxLabe5' />}
                  rules={[
                    {
                      required: true,
                      message: 'Input field is required'
                    },
                    {
                      validator: validateNamePrefixInput
                    }
                  ]}
                >
                  <Input  maxLength={20}/>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='SupplierReturnNo'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel4' />
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Input field is required'
                    },
                    {
                      validator: validateNumberInput
                    }
                  ]}
                >
                  <Input  maxLength={100}/>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              {getIsTaxExclusive && (
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                    name='DefaultSalesTax'
                    label={
                      <strong>
                        <IntlMessages id='setup.salesTax.salesTable2Label2' />
                      </strong>
                    }
                    rules={[
                      {
                        required: true,
                        message: 'Please select Sales Tax'
                      }
                    ]}
                    help={
                      <p>
                        <IntlMessages id='setup.salesTax.editSalesTaxLabelDesc' />
                      </p>
                    }
                  >
                    <Select
                      placeholder={
                        <IntlMessages id='setup.salesTax.salesTable2Label2' />
                      }
                      showSearch={checkIsWeb().exist}
                      optionFilterProp='children'
                    >
                      {taxData &&
                        taxData.map((e, key) => {
                          return (
                            <Select.Option value={e.id} key={e.id}>
                              {e.salesTaxName}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='orderNo'
                  label={<IntlMessages id='setup.salesTax.editSalesTaxLabe6' />}
                  rules={[
                    {
                      required: true,
                      message: 'Input field is required'
                    },
                    {
                      validator: validateNumberInput
                    }
                  ]}
                >
                  <Input maxLength={100}/>
                </Form.Item>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.salesTax.editOutletSubTitle2' />
            </h2>

            <Row className='SellScreenPrompts-div'>
              <Col lg={12} md={12} sm={24} xs={24}>
                <h4 style={{ textDecoration: 'underline' }}>
                  <IntlMessages id='setup.salesTax.editSalesTaxLabel7' />
                </h4>
                <Form.Item
                  // name='warnInventory'
                  // valuePropName='checked'
                  className='form-inner-pad-0'
                >
                  <Checkbox
                    checked={getIsWarnInventory}
                    onClick={() => setIsWarnInventory(!getIsWarnInventory)}
                  >
                    <p>
                      <IntlMessages id='setup.salesTax.editSalesTaxLabel7Desc' />
                    </p>
                  </Checkbox>
                </Form.Item>
              </Col>

              <Col lg={12} md={12} sm={24} xs={24}>
                <h4 style={{ textDecoration: 'underline' }}>
                  <IntlMessages id='setup.salesTax.editSalesTaxLabel8' />
                </h4>
                <Form.Item
                  // name='warnCustomer'
                  // valuePropName='checked'
                  className='form-inner-pad-0'
                >
                  <Checkbox
                    checked={getIsWarnCustomer}
                    onClick={() => setIsWarnCustomer(!getIsWarnCustomer)}
                  >
                    <p>
                      <IntlMessages id='setup.salesTax.editSalesTaxLabel8Desc' />{' '}
                    </p>
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.salesTax.editOutletSubTitle3' />
            </h2>

            <Row className='AddressandContact-div'>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment row-col-100'
                  name='Country'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel17' />
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select outlet's country"
                    }
                  ]}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='setup.salesTax.editSalesTaxLabel17' />
                    }
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                  >
                    {getCountryData &&
                      getCountryData.map(e => {
                        return (
                          <Select.Option value={e.id} key={e.id}>
                            {e.label}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Email'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel10' />
                  }
                  rules={[{ validator: isEmailValid }]}
                >
                  <Input  maxLength={50}/>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='City'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel12' />
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please mention outlet's city name"
                    }
                  ]}
                >
                  <Input maxLength={20}/>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Phone'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel13' />
                  }
                  rules={[
                    {
                      pattern: /^[0-9+\-() ]*$/,
                      message: 'Please enter a valid Phone number.',
                    },
                  ]}
                >
                  <Input  maxLength={20}/>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='StoreAddress'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel9' />
                  }
                >
                  <Input.TextArea />
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Twitter'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel15' />
                  }
                >
                  <Input maxLength={200}/>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='zipCodeXYZ'
                  label={
                    <IntlMessages id='setup.salesTax.editSalesTaxLabel14' />
                  }
                >
                  <InputNumber type='number' style={{ width: '100%' }}  maxLength={20}/>
                </Form.Item>
              </Col>

              {getTimeZoneList && getTimeZoneList.length > 0 && (
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                    name={'TimeZone'}
                    label={<IntlMessages id='setup.general.InputLabel7' />}
                  >
                    <Select
                      // size="large"
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel7' />
                      }
                      showSearch={checkIsWeb().exist}
                      optionFilterProp='children'
                    >
                      {getTimeZoneList.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.id}>
                            {e.label}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Row className='mt-2' justify='end' gutter={10}>
              <Col>
                <Button
                  className='dk-btn-cancel'
                  onClick={redirectToListing}
                  type='primary'
                  size='large'
                >
                  <IntlMessages id='products.promoadd.canbtn' />
                </Button>
              </Col>
              {showDelButton == '1' && (
                <Col>
                  <Button
                    className='dk-btn-cancel'
                    type='primary'
                    onClick={showDeleteConfirm}
                    size='large'
                    disabled={getIsDisableDelete}
                  >
                    <IntlMessages id='setup.userroles.delete' />
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  className='dk-btn-add'
                  htmlType='submit'
                  type='primary'
                  size='large'
                  disabled={getIsDisableUpdate}
                >
                  <IntlMessages id='products.promoadd.savbtn' />
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default EditOutlet
